export const enumToOptions = (enumObj: object) => {
  return Object.entries(enumObj).map(([key, value]) => ({
    value: key,
    label: value,
  }));
};
